import React from 'react';
import './Services.css';

function Services() {
  const services = [
    {
      icon: '🌐',
      title: 'Web Applications',
      description: 'Modern, responsive web applications built with cutting-edge technologies like React, Vue, and Node.js. Fast, scalable, and user-friendly.',
      features: ['Progressive Web Apps', 'E-commerce Platforms', 'Custom Dashboards', 'API Integration']
    },
    {
      icon: '📱',
      title: 'iOS Development',
      description: 'Native iOS apps that leverage the full power of Apple\'s ecosystem. Beautiful interfaces that follow iOS design guidelines perfectly.',
      features: ['Swift & SwiftUI', 'App Store Optimization', 'iCloud Integration', 'Apple Pay Support']
    },
    {
      icon: '🤖',
      title: 'Android Development',
      description: 'High-performance Android applications reaching billions of users. Built with Kotlin and modern Android development practices.',
      features: ['Material Design', 'Google Play Services', 'Multi-device Support', 'Offline Capabilities']
    },
    {
      icon: '🔄',
      title: 'Cross-Platform Apps',
      description: 'Build once, deploy everywhere. Cost-effective solutions using React Native or Flutter for iOS, Android, and web from a single codebase.',
      features: ['React Native', 'Flutter', 'Code Reusability', 'Faster Time to Market']
    },
    {
      icon: '🎨',
      title: 'UI/UX Design',
      description: 'Stunning user interfaces and seamless user experiences. We design with your users in mind, creating intuitive and engaging digital products.',
      features: ['Wireframing', 'Prototyping', 'User Research', 'Brand Integration']
    },
    {
      icon: '⚡',
      title: 'App Maintenance',
      description: 'Continuous support and updates to keep your app running smoothly. Bug fixes, performance optimization, and feature enhancements.',
      features: ['24/7 Support', 'Performance Monitoring', 'Security Updates', 'Feature Updates']
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive solutions for all your app development needs. From concept to launch and beyond.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index} style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="feature-check">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
